import { render, staticRenderFns } from "./HeaderAvatarPop.vue?vue&type=template&id=0bbc8f61&scoped=true"
import script from "./HeaderAvatarPop.vue?vue&type=script&lang=ts"
export * from "./HeaderAvatarPop.vue?vue&type=script&lang=ts"
import style0 from "./HeaderAvatarPop.vue?vue&type=style&index=0&id=0bbc8f61&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbc8f61",
  null
  
)

export default component.exports